import axios from "axios";

import { BASEURL } from '../helpers/constantes';
import {setToken} from './servicesGetCookie';
const AUTH_TOKEN2 = setToken();


 const api = axios.create(
    {
    baseURL: `${window.location.href.includes('localhost') || window.location.href.includes('192.168')? BASEURL:BASEURL+'/'}api/`,
    headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "Access-Control-Expose-Headers": "Access-Control-*",
        "Access-Control-Allow-Headers": "Access-Control-*, Origin, X-Requested-With, Content-Type, Accept",
        "Access-Control-Allow-Methods": "GET, POST, PUT, DELETE, OPTIONS, HEAD",
        "Access-Control-Allow-Origin": "*",
        "Cookie":`${AUTH_TOKEN2}`

    },
    withCredentials:true
});
api.interceptors.request.use(

    async function (config) {
        // Do something before request is sent
        const AUTH_TOKEN = setToken();
        config.headers.Authorization = `Bearer ${AUTH_TOKEN}`;
        config.xsrfCookieName = 'token';

        return config;
    },
    function (error) {
        // Do something with request error
        return Promise.reject(error);
    }
);


export default api;

